"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var chainable_1 = require("../chainable");

var observer_1 = require("../observer");

var BaseMulticast = function (_super) {
  __extends(BaseMulticast, _super);

  function BaseMulticast() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.subscribers = [];
    return _this;
  }

  BaseMulticast.prototype.complete = function () {
    this.subscribers.forEach(function (subscriber) {
      return subscriber.complete();
    });
  };

  BaseMulticast.prototype.error = function (err) {
    this.subscribers.forEach(function (subscriber) {
      return subscriber.error(err);
    });
  };

  BaseMulticast.prototype.update = function (v) {
    for (var i = 0; i < this.subscribers.length; i++) {
      this.subscribers[i].update(v);
    }
  };

  BaseMulticast.prototype.subscribe = function (observerCandidate) {
    var _this = this;

    var observer = observer_1.default(observerCandidate, this.props);
    this.subscribers.push(observer);
    var subscription = {
      unsubscribe: function unsubscribe() {
        var index = _this.subscribers.indexOf(observer);

        if (index !== -1) _this.subscribers.splice(index, 1);
      }
    };
    return subscription;
  };

  BaseMulticast.prototype.stop = function () {
    if (this.parent) this.parent.stop();
  };

  BaseMulticast.prototype.registerParent = function (subscription) {
    this.stop();
    this.parent = subscription;
  };

  return BaseMulticast;
}(chainable_1.default);

exports.BaseMulticast = BaseMulticast;